import { StartClient } from '@tanstack/react-start/client';
import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import './index.css';
import './i18n/config';

async function maybeStartMsw() {
  if (!import.meta.env.DEV) return;
  if (import.meta.env.VITE_MSW !== 'true') return;
  const { worker } = await import('./mocks/browser');
  await worker.start({
    onUnhandledRequest: 'bypass',
  });
}

void maybeStartMsw();

hydrateRoot(
  document,
  <StrictMode>
    <StartClient />
  </StrictMode>
);

